<div
  class="ingrid-button"
  [ngClass]="{ 'ingrid-button_disabled': disabled, 'ingrid-button_menu-shown': showMenuToggle }"
>
  <div class="ingrid-button__body">
    <button class="ingrid-button__button" (click)="clickHandler($event)">
      <span class="ingrid-button__text">
        <ng-content></ng-content>
      </span>
    </button>

    <button *ngIf="showMenuToggle" (click)="menuClickHandler($event)" class="ingrid-button__dots">
      <i class="material-icons">more_horiz</i>
    </button>
  </div>
  <div class="ingrid-button__progress" *ngIf="progress"></div>
</div>
